module.exports = __webpack_public_path__ + "static/sm-48089e013d13e1e6a5fa3d62c817b618.svg";